<template>
  <div class="bargain-card">
    <div class="card-header">
      <div class="status-tag" :class="'status-tag--' + Number(cardDetail.displayStatus)">
        {{ displayStatusText }}
      </div>
      <div v-if="Number(cardDetail.displayStatus) === 3" class="countdown">
        <span class="countdown-time payTime">已完成于&nbsp;{{ payTimeText }}</span>
      </div>
      <div v-else-if="Number(cardDetail.status) === 7" class="countdown">
        <img
          class="countdown-icon"
          referrerpolicy="no-referrer"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/time.png"
        />
        <span class="countdown-time">{{cardDetail.displayStatus==2?'支付':''}}剩&nbsp;{{ countdownText }}</span>
      </div>
    </div>

    <div class="card-divider"></div>

    <div class="course-info">
      <img class="course-cover" :src="getCoverUrl(cardDetail.coverMobile)" alt="" />
      <div class="course-detail">
        <div class="course-name">{{ cardDetail.productName }}</div>
        <div class="start-time">发起时间：{{ shareTimeText }}</div>
        <div class="price-row">
          <div class="current-price">
            <span class="price-symbol">¥</span>
            <span class="price-value">{{ cardDetail.floorPrice }}</span>
          </div>
          <span class="original-price">¥{{ cardDetail.originalPrice }}</span>
        </div>
      </div>

      <div class="cut-badge">已砍¥{{ bargainAmount }}</div>
    </div>

    <div class="progress-bar">
      <div class="progress-track">
        <div class="progress-fill" :style="{ width: progressWidth + '%' }">
          <img
            class="progress-knife"
            referrerpolicy="no-referrer"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/dot.png"
          />
        </div>
      </div>
    </div>

    <div class="invite-tip" v-if="cardDetail.displayStatus!=3">
      <span v-if="cardDetail.displayStatus==2" class="tip-text">已砍至底价，请在活动结束前完成支付</span>
      <span v-if="cardDetail.displayStatus==1" class="tip-text">
        已邀请 <span class="tip-highlight">{{ currentAssistNum }}</span> 位好友，再邀请<span class="tip-highlight">{{ remainInviteNum }}</span>人 砍至底价
      </span>
     <span v-if="cardDetail.displayStatus==4" class="tip-text">
        已邀请 <span class="tip-highlight">{{ currentAssistNum }}</span> 位好友，邀请人数不足
      </span>

    </div>
  </div>
</template>

<script>
import { replaceHyphens } from '@/utils/tools';

const DISPLAY_STATUS_MAP = {
  1: '砍价中',
  2: '待支付',
  3: '已购买',
  4: '已过期',
};

export default {
  props: {
    cardDetail: {
      type: Object,
      default: () => ({}),
    },
    nowTime: {
      type: [String, Number],
    },
  },
  data() {
    return {
      countdownText: '00:00:00',
      timers: null,
    };
  },
  computed: {
    displayStatusText() {
      return DISPLAY_STATUS_MAP[Number(this.cardDetail.displayStatus)] || '';
    },
    shareTimeText() {
      const { shareTime } = this.cardDetail;
      if (!shareTime) return '';
      return shareTime.slice(5, 16);
    },
    payTimeText() {
      const { payTime } = this.cardDetail;
      if (!payTime) return '';
      return String(payTime).slice(5, 10);
    },
    bargainAmount() {
      const original = Number(this.cardDetail.originalPrice) || 0;
      const current = Number(this.cardDetail.bargainPrice) || 0;
      const amount = original - current;
      return amount > 0 ? amount.toFixed(0) : '0.00';
    },
    progressWidth() {
      const original = Number(this.cardDetail.originalPrice) || 0;
      const current = Number(this.cardDetail.bargainPrice) || 0;
      const floor = Number(this.cardDetail.floorPrice) || 0;
      const total = original - floor;
      if (total <= 0) return 0;
      const progress = ((original - current) / total) * 100;
      return Math.min(Math.max(progress, 0), 100);
    },
    currentAssistNum() {
      return Number(this.cardDetail.currentAssistNum) || 0;
    },
    lastLadderInviteNum() {
      const ladderList = this.cardDetail.ladderList || [];
      if (!ladderList.length) return 0;
      return Number(ladderList[ladderList.length - 1].inviteNum) || 0;
    },
    remainInviteNum() {
      const remain = this.lastLadderInviteNum - this.currentAssistNum;
      return remain > 0 ? remain : 0;
    },
  },
  watch: {
    nowTime() {
      this.tryInitCountdown();
    },
  },
  mounted() {
    this.tryInitCountdown();
  },
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    getCoverUrl(coverMobile = '') {
      return String(coverMobile).split(',')[0] || '';
    },
    tryInitCountdown() {
      if (Number(this.cardDetail.status) !== 7) return;
      this.initCountdown();
    },
    parseTime(time) {
      if (time === null || time === undefined || time === '') return NaN;
      if (typeof time === 'number') return time;
      const timestamp = new Date(replaceHyphens(String(time))).getTime();
      return Number.isNaN(timestamp) ? NaN : timestamp;
    },
    initCountdown() {
      clearInterval(this.timers);
      const currentTime = this.parseTime(this.nowTime);
      const activityEndTime = this.parseTime(this.cardDetail.endTime);
      if (!currentTime || !activityEndTime) {
        this.countdownText = '00:00:00';
        return;
      }
      let remain = activityEndTime - currentTime;

      const updateCountdown = () => {
        if (remain <= 0) {
          this.countdownText = '00:00:00';
          clearInterval(this.timers);
          return;
        }
        if (remain > 24 * 60 * 60 * 1000) {
          const days = Math.floor(remain / 1000 / 60 / 60 / 24);
          const hours = Math.floor((remain / 1000 / 60 / 60) % 24);
          const minutes = Math.floor((remain / 1000 / 60) % 60);
          const seconds = Math.floor((remain / 1000) % 60);
          this.countdownText = `${days}天${hours}小时${minutes}分${seconds}秒`;
          return;
        }
        const h = String(Math.floor(remain / 1000 / 60 / 60)).padStart(2, '0');
        const m = String(Math.floor((remain / 1000 / 60) % 60)).padStart(2, '0');
        const s = String(Math.floor((remain / 1000) % 60)).padStart(2, '0');
        this.countdownText = `${h}:${m}:${s}`;
      };

      updateCountdown();
      this.timers = setInterval(() => {
        remain -= 1000;
        updateCountdown();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.bargain-card {
  box-sizing: border-box;
  width: 100%;
  margin-top: 24px;
  padding: 24px 32px 40px;
  background-color: #fff;
  border-radius: 20px;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .status-tag {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      width: 94px;
      height: 31px;
      font-size: 22px;
      line-height: 31px;
      white-space: nowrap;
      text-align: center;
      border-radius: 18px;

      &--1 {
        color: #ff7f41;
        background: #ffe9df;
        border: 1px solid #ffcab0;
      }

      &--2 {
        color: #6e98ff;
        background: #eff3ff;
        border: 1px solid #c3d4ff;
      }

      &--3 {
        color: #00ca51;
        background: #e8fff1;
        border: 1px solid #b3ebc9;
      }

      &--4 {
        color: #999;
        background: #dcdcdc;
        border: 1px solid #999;
      }
    }

    .countdown {
      display: flex;
      align-items: center;

      .countdown-icon {
        width: 40px;
        height: 40px;
      }

      .countdown-time {
        margin-left: 8px;
        color: #ff3938;
        font-size: 28px;
        line-height: 40px;
        white-space: nowrap;
      }
      .payTime{
        color: #333 !important;
      }
    }
  }

  .card-divider {
    height: 2px;
    margin-top: 16px;
    background-color: #f5f5f5;
  }

  .course-info {
    position: relative;
    display: flex;
    margin-top: 32px;

    .course-cover {
      flex-shrink: 0;
      width: 188px;
      height: 137px;

      &--empty {
        background-color: #f5f5f5;
      }
    }

    .course-detail {
      flex: 1;
      min-width: 0;
      margin-left: 14px;

      .course-name {
        overflow: hidden;
        color: #333;
        font-weight: 500;
        font-size: 28px;
        line-height: 36px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .start-time {
        margin-top: 12px;
        color: #999;
        font-size: 24px;
        line-height: 36px;
        white-space: nowrap;
      }

      .price-row {
        display: flex;
        align-items: center;
        margin-top: 18px;

        .current-price {
          display: flex;
          align-items: baseline;
          height: 56px;
          line-height: 40px;

          .price-symbol {
            color: #ff3938;
            font-weight: 600;
            font-size: 28px;
          }

          .price-value {
            color: #ff3938;
            font-weight: 600;
            font-size: 40px;
            line-height: 40px;
          }
        }

        .original-price {
          margin-left: 16px;
          padding-bottom: 4px;
          color: #ccc;
          font-size: 20px;
          line-height: 28px;
          text-decoration: line-through;
        }
      }
    }

    .cut-badge {
      position: absolute;
      right: 0;
      bottom: 6px;
      min-width: 143px;
      height: 38px;
      padding: 0 5px;
      color: #fff;
      font-weight: 500;
      font-size: 24px;
      line-height: 38px;
      white-space: nowrap;
      text-align: center;
      background: #ff3938;
      background-color: #ff3938;
      border-radius: 5px 5px 5px 5px;
    }
  }

  .progress-bar {
    margin-top: 24px;

    .progress-track {
      position: relative;
      height: 10px;
      background-color: #f5f5f5;
      border-radius: 10px;

      .progress-fill {
        position: relative;
        min-width: 10px;
        height: 100%;
        background-color: #ff7f41;
        border-radius: 10px;

        .progress-knife {
          position: absolute;
          top: 50%;
          right: -14px;
          width: 28px;
          height: 28px;
          transform: translateY(-50%);
        }
      }
    }
  }

  .invite-tip {
    margin-top: 24px;
    font-size: 0;
    line-height: 34px;
    white-space: nowrap;

    .tip-text {
      color: #333;
      font-size: 24px;
      line-height: 34px;
    }

    .tip-highlight {
      color: #ff7f41;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
    }
  }
}
</style>
